/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MobileBootstrapTokenRequest } from '../models/MobileBootstrapTokenRequest';
import type { MobileBootstrapTokenResponse } from '../models/MobileBootstrapTokenResponse';
import type { MobileLaunchChallengeRequest } from '../models/MobileLaunchChallengeRequest';
import type { MobileLaunchChallengeResponse } from '../models/MobileLaunchChallengeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileSsoService {
    /**
     * Mint mobile SSO bootstrap launch URL
     * Mints a single-use, short-lived launch URL for the mobile in-app browser SSO flow. Authenticated via X-Mobile-Auth (the standard mobile session header). The mobile supplies the target app_id; the BFF resolves the SSO protocol (SAML vs OAuth) and returns a fully-built launch_url to open in the in-app browser.
     * @param requestBody
     * @param xDeviceProof
     * @param xMobileAuth
     * @returns MobileBootstrapTokenResponse Successful Response
     * @throws ApiError
     */
    public static mintMobileBootstrapToken(
        requestBody: MobileBootstrapTokenRequest,
        xDeviceProof?: (string | null),
        xMobileAuth?: (string | null),
    ): CancelablePromise<MobileBootstrapTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v1/sso/bootstrap-token',
            headers: {
                'X-Device-Proof': xDeviceProof,
                'X-Mobile-Auth': xMobileAuth,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Application sso_type does not support direct-login`,
                401: `The device proof names no application`,
                403: `Authenticated user is not assigned to the application`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Issue an in-app SSO launch challenge
     * Issues a single-use challenge the device signs with its hardware key before requesting a launch URL. The identity the challenge is bound to comes from the X-Mobile-Auth session; the body carries only the target app_id. The returned auth_requirement is the ceremony hint for the client — nothing server-side enforces it.
     * @param requestBody
     * @param xMobileAuth
     * @returns MobileLaunchChallengeResponse Successful Response
     * @throws ApiError
     */
    public static createLaunchChallenge(
        requestBody: MobileLaunchChallengeRequest,
        xMobileAuth?: (string | null),
    ): CancelablePromise<MobileLaunchChallengeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v1/sso/challenge',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Launching the application is not allowed`,
                422: `Validation Error`,
                503: `The authentication requirement could not be resolved`,
            },
        });
    }
}
